module.exports = __webpack_public_path__ + "img/icn_check_hv_kizu.b3b98e5f.png";